<template>
  <div>
    <van-dropdown-menu active-color="#ee0a24">
      <van-dropdown-item :title="districttitle" ref="district">
        <van-tree-select
          :items="items"
          :active-id.sync="activeId"
          :main-active-index.sync="activeIndex"
          @click-item="itemDistrict"
        />
        <div style="margin: 15px">
          <van-button type="info" block @click="resetDistrict()"
            >不限小区</van-button
          >
        </div>
      </van-dropdown-item>
      <van-dropdown-item :title="zujintitle" ref="zujin">
        <div class="zujin-box">
          <h1>选择租金</h1>
          <van-row :gutter="10">
            <van-col :span="6" v-for="(item, index) in zujin" :key="index">
              <div
                :class="{
                  'form-box-tag': true,
                  active: currentIndex == index ? true : false,
                }"
                @click="swap(index, item, 1)"
              >
                {{ item }}
              </div>
            </van-col>
          </van-row>
          <div class="zujin-b">
            <div class="zujin-b-1">
              <van-button block @click="reset(1)">不限条件</van-button>
            </div>
            <div class="zujin-b-2">
              <van-button type="info" block @click="send(1)">确认</van-button>
            </div>
          </div>
        </div>
      </van-dropdown-item>
      <van-dropdown-item :title="huxingtitle" ref="huxing">
        <div class="zujin-box">
          <h1>选择户型</h1>
          <van-row :gutter="10">
            <van-col :span="6" v-for="(item, index) in huxing" :key="index">
              <div
                :class="{
                  'form-box-tag': true,
                  active: huxingIndex == index ? true : false,
                }"
                @click="swap(index, item, 2)"
              >
                {{ item }}
              </div>
            </van-col>
          </van-row>
          <div class="zujin-b">
            <div class="zujin-b-1">
              <van-button block @click="reset(2)">不限条件</van-button>
            </div>
            <div class="zujin-b-2">
              <van-button type="info" block @click="send(2)">确认</van-button>
            </div>
          </div>
        </div>
      </van-dropdown-item>
      <van-dropdown-item title="筛选" ref="filter">
        <div class="zujin-box">
          <h1>选择面积</h1>
          <van-row :gutter="10">
            <van-col :span="6" v-for="(item, index) in mianji" :key="index">
              <div
                :class="{
                  'form-box-tag': true,
                  active: mianjiIndex == index ? true : false,
                }"
                @click="swap(index, item, 3)"
              >
                {{ item }}
              </div>
            </van-col>
          </van-row>
          <h1>来源</h1>
          <van-row :gutter="10">
            <van-col :span="6" v-for="(item, index) in laiyuan" :key="index">
              <div
                :class="{
                  'form-box-tag': true,
                  active: laiyuanIndex == index ? true : false,
                }"
                @click="swap(index, item, 4)"
              >
                {{ item }}
              </div>
            </van-col>
          </van-row>
          <h1>出租方式</h1>
          <van-row :gutter="10">
            <van-col :span="6" v-for="(item, index) in chuzu" :key="index">
              <div
                :class="{
                  'form-box-tag': true,
                  active: chuzuIndex == index ? true : false,
                }"
                @click="swap(index, item, 5)"
              >
                {{ item }}
              </div>
            </van-col>
          </van-row>
          <div class="zujin-b">
            <div class="zujin-b-1">
              <van-button block @click="reset(3)">不限条件</van-button>
            </div>
            <div class="zujin-b-2">
              <van-button type="info" block @click="send(3)">确认</van-button>
            </div>
          </div>
        </div>
      </van-dropdown-item>
    </van-dropdown-menu>
  </div>
</template>

<script>
import { Row, Col, DropdownMenu, DropdownItem, TreeSelect, Button } from "vant";

export default {
  components: {
    [Row.name]: Row,
    [Col.name]: Col,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    [TreeSelect.name]: TreeSelect,
    [Button.name]: Button,
  },

  data() {
    return {
      activeId: -1,
      activeIndex: 0,
      currentIndex: -1,
      zujinIndex: -1,
      laiyuanIndex: -1,
      huxingIndex: -1,
      mianjiIndex: -1,
      chuzuIndex: -1,
      laiyuan: ["个人", "中介"],
      chuzu: ["整租", "合租"],
      districttitle: "区域",
      zujintitle: "租金",
      huxingtitle: "户型",
      filter: {},
      lists: [],
    };
  },
  props: {
    items: Array,
    zujin: Array,
    huxing: Array,
    mianji: Array,
  },
  mounted() {
    this.lists = this.items;
  },

  methods: {
    swap(index, item, type) {
      if (type == 1) {
        this.currentIndex = index;
        this.zujintitle = item;
        this.filter.price = index;
      }
      if (type == 2) {
        this.huxingIndex = index;
        this.huxingtitle = item;
        this.filter.huxing = index;
      }
      if (type == 3) {
        this.mianjiIndex = index;
        this.filter.mianji = index;
      }
      if (type == 4) {
        this.laiyuanIndex = index;
        this.filter.laiyuan = index;
      }
      if (type == 5) {
        this.chuzuIndex = index;
        this.filter.type = index;
      }
    },
    itemDistrict(data) {
      console.log(data);
      this.$refs.district.toggle();
      this.districttitle = data.text;
      this.filter.district = data.text;
      this.$emit("change", this.filter);
    },
    reset(index) {
      // this.close(index);
      if (index == 1) {
        this.zujintitle = "租金";
        this.currentIndex = -1;
        delete this.filter.price;
        this.$refs.zujin.toggle();
      }
      if (index == 2) {
        this.huxingtitle = "户型";
        this.huxingIndex = -1;
        delete this.filter.huxing;
        this.$refs.huxing.toggle();
      }
      if (index == 3) {
        this.mianjiIndex = -1;
        this.laiyuanIndex = -1;
        this.chuzuIndex = -1;
        delete this.filter.mianji;
        delete this.filter.laiyuan;
        delete this.filter.type;
        this.$refs.filter.toggle();
      }
      this.$emit("change", this.filter);
    },
    send(index) {
      console.log(this.filter);
      this.close(index);
      this.$emit("change", this.filter);
    },
    close(index) {
      if (index == 1) {
        this.$refs.zujin.toggle();
      }
      if (index == 2) {
        this.$refs.huxing.toggle();
      }
      if (index == 3) {
        this.$refs.filter.toggle();
      }
    },
    resetDistrict() {
      this.$refs.district.toggle();
      this.districttitle = "区域";
      this.activeId = -1;
      this.activeIndex = 0;
      delete this.filter.district;
      this.$emit("change", this.filter);
    },
  },
};
</script>

<style scoped>
.form-box-tag {
  background-color: #f8f8f8;
  line-height: 36px;
  text-align: center;
  color: #555;
  border-radius: 4px;
  cursor: pointer;
  margin-top: 15px;
}
.form-box-tag.active {
  background-color: #feefe9;
  color: #f56229;
}
.zujin-box {
  padding: 0 15px 15px 15px;
}
.zujin-box h1 {
  font-size: 18px;
  margin-top: 15px;
}
.zujin-b {
  border-top: #f8f8f8 1px solid;
  display: flex;
  justify-content: space-between;
  padding-top: 15px;
  margin-top: 15px;
}
.zujin-b-1 {
  width: 50%;
  margin: 0 10px;
}
.zujin-b-2 {
  width: 50%;
  margin: 0 10px;
}
</style>>



